const numFormat = new Intl.NumberFormat('ko-KR');

const krwFormat = Intl.NumberFormat('ko-KR', {
  style: 'currency',
  currency: 'KRW',
});

export const toPhoneNumFormat = (value: string) => {
  return value.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
};

export const toPriceKRW = (value?: number) => {
  if (!value) return 0;
  return krwFormat.format(value);
};

export const presentNumber = (num: number) => numFormat.format(num);
